<template>
    <v-navigation-drawer 
        app
        :mini-variant.sync="mini"
        v-model="openMenu"
    >
        <v-list>
            <v-list-item :style="mini ? 'height: 51px !important;': 'margin-left: 18%;'">
                <a href="/" v-if="mini == false">
                    <v-img :src="require('@/assets/images/logo.png')" max-height="130" max-width="130" />
                </a>
                <v-app-bar-nav-icon
                    v-else
                    @click.stop="openCloseSideMenu" style="border: none; margin-left: -5px;">
                    <v-icon 
                        color="var(--color__cinza_escuro)"
                    >
                        mdi-playlist-plus
                    </v-icon>
                </v-app-bar-nav-icon>
            </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <!-- FIXEDs MENU -->
        <v-list dense>
            
            <a href="/" style="text-decoration: none !important;">
                <v-list-item 
                    link
                >
                    <v-tooltip right>
                        <template v-slot:activator="{ on }">
                            <v-list-item-icon v-on="on">
                                <v-icon color="var(--color__main)">mdi mdi-home</v-icon>
                            </v-list-item-icon>

                            <v-list-item-title>Home</v-list-item-title>

                        </template>
                        <span>Go to Home</span>
                    </v-tooltip>
                </v-list-item>
            </a>
                        
            <v-list-item 
                v-if="accessCompletedJobs"
                link 
                :to="{ name: 'completedJobs' }"
            >
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-icon color="var(--color__main)">mdi mdi-coffee-maker-check</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>Completed Jobs</v-list-item-title>

                    </template>
                    <span>Completed Jobs</span>
                </v-tooltip>
            </v-list-item>


            <v-list-item v-if="mini == false">

                <v-list-item-title class="titleMenu">Notifications</v-list-item-title>

            </v-list-item>

                        
            <v-list-item 
                v-if="!isReadOnlyAccess"
                link 
                :to="{ name: 'toDoUrgent', params: { categoryName: ' - Urgent' } }" 
                :key="-5" 
                @click="setIDToDoCategory(1, 0, 0, 0)"
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtUrgent"
                                :value="$store.state.notificationModule.qtUrgent"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-fire</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Urgent</v-list-item-title>

                    </template>
                    <span>Urgent</span>
                </v-tooltip>
            </v-list-item>

                        
            <v-list-item 
                v-if="!isReadOnlyAccess"
                link 
                :to="{ name: 'toDoSystem', params: { categoryName: ' - System' } }" 
                :key="-4"
                @click="setIDToDoCategory(0, 1, 0, 0)"
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtSystem"
                                :value="$store.state.notificationModule.qtSystem"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-bell</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>System</v-list-item-title>
                    </template>
                    <span>System</span>
                </v-tooltip>

            </v-list-item>
                        
                        
            <v-list-item 
                v-if="!isReadOnlyAccess"
                link 
                :to="{ name: 'toDoAssignedToMe', params: { categoryName: ' - Assigned To Me' } }" 
                :key="-3"
                @click="setIDToDoCategory(0, 0, 1, 0)"
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtAssignedToMe"
                                :value="$store.state.notificationModule.qtAssignedToMe"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-clipboard-check</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Assigned To Me</v-list-item-title>
                    </template>
                    <span>Assigned To Me</span>
                </v-tooltip>

            </v-list-item>
                        
                        
            <v-list-item 
                v-if="accessInspection"
                link 
                :to="{ name: 'inspection' }" 
                :key="-2"                
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtdInspection"
                                :value="$store.state.notificationModule.qtdInspection"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-magnify-expand</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Inspections</v-list-item-title>
                    </template>
                    <span>Inspections</span>
                </v-tooltip>

            </v-list-item>
                        
                        
            <v-list-item 
                v-if="accessInspectionRequest"
                link 
                :to="{ name: 'inspectionRequest' }" 
                :key="-2"                
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtdInspectionRequest"
                                :value="$store.state.notificationModule.qtdInspectionRequest"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-magnify-plus</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Inspection Requests</v-list-item-title>
                    </template>
                    <span>Inspection Requests</span>
                </v-tooltip>

            </v-list-item>
                        
                        
            <v-list-item 
                v-if="accessWorkOrder"
                link 
                :to="{ name: 'workOrder' }" 
                :key="-1"                
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtdWorkOrder"
                                :value="$store.state.notificationModule.qtdWorkOrder"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-briefcase-outline</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Work Order</v-list-item-title>
                    </template>
                    <span>Work Order</span>
                </v-tooltip>

            </v-list-item>
            
            <v-list-item 
                v-if="accessWorkOrderRequest"
                link 
                :to="{ name: 'workOrderRequest' }" 
                :key="-1"                
            >

                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.qtdWorkOrderRequest"
                                :value="$store.state.notificationModule.qtdWorkOrderRequest"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">mdi mdi-briefcase</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>Work Order Request</v-list-item-title>
                    </template>
                    <span>Work Order Request</span>
                </v-tooltip>

            </v-list-item>

            <v-list-item 
                v-for="(itemToDoCateogory, index) in userLoggedGetters.listToDoCategory" 
                :key="index" 
                link 
                :to="{ name: itemToDoCateogory.routeName, params: { categoryName: ' - ' + itemToDoCateogory.description } }"
                @click="setIDToDoCategory(0, 0, 0, itemToDoCateogory.id)"
            >                                 
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <v-list-item-icon v-on="on">
                            <v-badge
                                :content="$store.state.notificationModule.listToDoByCategory.filter(cat => cat.idTodoCategory === itemToDoCateogory.id).length"
                                :value="$store.state.notificationModule.listToDoByCategory.filter(cat => cat.idTodoCategory === itemToDoCateogory.id).length"
                                left
                                overlap
                                color="var(--color__red)"
                            >
                                <v-icon color="var(--color__main)">{{ itemToDoCateogory.mdiIcon }}</v-icon>
                            </v-badge>
                        </v-list-item-icon>

                        <v-list-item-title>{{ itemToDoCateogory.description }}</v-list-item-title>
                    </template>
                    <span>{{ itemToDoCateogory.description }}</span>
                </v-tooltip>

            </v-list-item>

        </v-list>

        <v-divider></v-divider>

        <!-- MENU -->
        <v-list dense v-if="itemGrupoMenu !== null">

            <v-list-item v-if="mini == false">

                <v-list-item-title class="titleMenu">Menu</v-list-item-title>

            </v-list-item>
                        
            <v-list-item 
                v-for="(itemMenu, index) in itemGrupoMenu.listMenu.filter(mnu => mnu.showInMenu === true)" 
                :key="index" 
                link 
                :to="`${itemMenu.path}`"
                @click="setIDToDoCategory(0, 0, 0, 0)"
            >
                <v-tooltip right>
                    <template v-slot:activator="{ on }">

                        <v-list-item-icon v-on="on">
                            <v-icon color="var(--color__main)">{{ itemMenu.mdiIcon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title>{{ itemMenu.description }}</v-list-item-title>

                    </template>
                    <span>{{ itemMenu.description }}</span>
                </v-tooltip>

            </v-list-item>

        </v-list>

    </v-navigation-drawer>

</template>

<script>
    
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ReadOnlyAccess from '@/utilities/ReadOnlyAccess';
    import notificationSignalRService from '@/services/notificationSignalRService';

    export default {

        mixins: [Helpers, ReadOnlyAccess],

        data: () => ({

            itemGrupoMenu: null,
            accessWorkOrder: false,
            accessWorkOrderRequest: false,
            accessInspection: false,
            accessInspectionRequest: false,
            accessCompletedJobs: false,
            openMenu: null,

            timerDocusign: null,
            timerCreateAutoToDo: null,
            showedModalToDo: false
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState', menuGetter: 'menuState' }),

            isIntegrationAccess() {
                return this.userLoggedGetters.profile?.integration == 1;
            },

            mini: {
                get: function() {
                    return this.$store.state.menuSide
                },
                
                set: function () { }
            }
        },

        watch: {
            "menuGetter.reload"() {
                this.itemGrupoMenu = this.menuGetter.itemGrupoMenu;

                let itemGrupoMenuFiltered = this.itemGrupoMenu.listMenu.filter(mnu => mnu.showInMenu === true);

                if (itemGrupoMenuFiltered.length != 0) {
                    
                    this.$router.push({ path: itemGrupoMenuFiltered[0].path });
                }
                else {
                    itemGrupoMenuFiltered = this.itemGrupoMenu.listMenu.filter(mnu => mnu.id == this.userLoggedGetters.profile.idMenuDefault)[0];

                    if (itemGrupoMenuFiltered != null || itemGrupoMenuFiltered != undefined) {
                        this.$router.push({ path: itemGrupoMenuFiltered.path });
                    }
                }
            },

            "$vuetify.breakpoint.mobile"() {

                this.checkMobile();
            },

            "$store.state.menuSide"() {

                this.checkMobile();
            }
        },

        methods: {

            checkMobile() {
                if (this.$vuetify.breakpoint.mobile == true) {
                    this.openMenu = true;
                }
                else {
                    this.openMenu = null;
                }
            },

            openCloseSideMenu() {
                this.checkMobile();
                var menuSide = !this.$store.state.menuSide;
                this.openSideMenu(menuSide)
            },
            
            setIDToDoCategory(urgent, system, assignedToMe, idTodoCategory) {
                let jsonToDoCategory = {
                    urgent,
                    system,
                    assignedToMe,
                    idTodoCategory,
                    done: null
                }

                localStorage.setItem('jsonToDoCategory', JSON.stringify(jsonToDoCategory));
            },
            
            async checkAccess() {
                this.accessWorkOrder = false;
                this.accessWorkOrderRequest = false;
                this.accessInspection = false;
                this.accessInspectionRequest = false;
                this.accessCompletedJobs = false;

                const listRoutesFromLocalStorage = localStorage.getItem('listRouters');

                if (listRoutesFromLocalStorage !== null && listRoutesFromLocalStorage !== undefined) {
                    const listRoutesJSON = JSON.parse(listRoutesFromLocalStorage)

                    let accessRoute = listRoutesJSON.filter(rte => rte.name == 'workOrder');
                    this.accessWorkOrder = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'workOrderRequest');
                    this.accessWorkOrderRequest = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'inspection');
                    this.accessInspection = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'inspectionRequest');
                    this.accessInspectionRequest = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;

                    accessRoute = listRoutesJSON.filter(rte => rte.name == 'completedJobs');
                    this.accessCompletedJobs = accessRoute != null && accessRoute != undefined && accessRoute.length > 0;
                }

            },

            async startPollingNotifications() {
                if (this.isIntegrationAccess) return;
                // Fallback: only used if SignalR is unavailable.
                // CheckJobsPendingAcceptance and CheckAppointmentConfirmation are now
                // handled by a server-side background service (ServiceNotificationBackgroundService).
                const token = localStorage.getItem("token");
                if (!token) return;

                // verifica popup urgente
                const qtUrgent = this.$store.state.notificationModule.qtUrgent;
                if (qtUrgent > 0 && !this.showedModalToDo) {
                    this.showedModalToDo = true;
                    this.showModalToDo(qtUrgent);
                }

                this.timerNotifications = setTimeout(this.startPollingNotifications, 300000);
            },

            async startNotificationHub() {
                if (this.isIntegrationAccess) return;
                const token = localStorage.getItem("token");
                if (!token) return;

                await notificationSignalRService.connect((summary) => {
                    this.$store.commit("notificationModule/setNotifications", {
                        qtUrgent: summary.qtUrgent ?? 0,
                        qtSystem: summary.qtSystem ?? 0,
                        qtAssignedToMe: summary.qtAssignedToMe ?? 0,
                        listToDoByCategory: summary.listToDoByCategory ?? [],
                        qtdWorkOrder: summary.qtdWorkOrder ?? 0,
                        qtdWorkOrderRequest: summary.qtdWorkOrderRequest ?? 0,
                        qtdInspection: summary.qtdInspection ?? 0,
                        qtdInspectionRequest: summary.qtdInspectionRequest ?? 0,
                    });

                    const qtUrgent = summary.qtUrgent ?? 0;
                    if (qtUrgent > 0 && !this.showedModalToDo) {
                        this.showedModalToDo = true;
                        this.showModalToDo(qtUrgent);
                    }
                });
            },

            async startPollingDocusign() {
                if (this.isIntegrationAccess) return;
                const token = localStorage.getItem("token");
                if (!token) return;

                await this.$store.dispatch("docusignModule/CheckAllPendingDocuments");
                this.timerDocusign = setTimeout(this.startPollingDocusign, 3600000);
            },

            async startPollingCreateAutoToDo() {
                if (this.isIntegrationAccess) return;
                const token = localStorage.getItem("token");
                if (!token) return;

                await this.$store.dispatch("toDoManagerModule/CreateAutoToDo", null, { root: true });
                this.timerCreateAutoToDo = setTimeout(this.startPollingCreateAutoToDo, 3600000);
            }
        },

        beforeUnmount() {
            notificationSignalRService.disconnect();
            clearTimeout(this.timerDocusign);
            clearTimeout(this.timerCreateAutoToDo);
        },

        async created() {
            await this.checkAccess();
            this.startNotificationHub();
            this.startPollingDocusign();
            this.startPollingCreateAutoToDo();
        }
    };

</script>

<style>
    .v-badge__badge {
        border: solid 2px;
    }
</style>